import { RestCompetitonResult } from '@/types'
import axios from 'axios'
import host from '../../utils/host'

class CompetitionRest {
  private host: string = host

  subscribe (campaignId: number, email: string, name: string, country: string): Promise<RestCompetitonResult> {
    return axios.post(`${this.host}/api/users/me/competitions/${campaignId}`, {
      display_name: name,
      email,
      country_code: country,
    })
  }
}

export default new CompetitionRest()
